// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"49287f0c","192":"abbb42d7","314":"f853a26d","751":"1fea1abf"}[chunkId] + ".chunk.css";
};